<template>
    <div class="home">
        <div class="headCont">
            <div class="leftCont">
                <div class="imgCont">
                    <el-avatar
                        class="avatar"
                        :src=" userInfo.avatar || avatar"
                        :size="80"
                    >
                    </el-avatar>
                </div>
                <div class="cont">
                    <div class="welcome">欢迎您，祝你工作顺利，加油！</div>
                    <br />
                    <div class="job">
                        {{ userInfo.position }} | {{ userInfo.depart_name }}
                    </div>
                </div>
            </div>

            <div class="aboutChecking">
                <div
                    class="itemCont"
                    @click="showAuditCheck"
                    v-if="userInfo.tobe_pending_num"
                >
                    <div class="titleCont">
                        <div class="auditIcon">
                            <i class="iconfont icon-kaoqin"></i>
                        </div>
                        <div class="title">待审核考勤</div>
                    </div>
                    <div class="numCont">
                        {{ userInfo.tobe_pending_num }}
                    </div>
                </div>

                <div
                    class="itemCont"
                    @click="showSureCheck"
                    v-if="userInfo.tobe_confirmed_num"
                >
                    <div class="titleCont">
                        <div class="sureIcon">
                            <i class="iconfont icon-shenpi"></i>
                        </div>
                        <div class="title">待确认考勤</div>
                    </div>
                    <div class="numCont">
                        {{ userInfo.tobe_confirmed_num }}
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="leftCont">
                <div class="fastCont">
                    <div class="btnCont" @click="showMine('我的审批')">
                        <div class="iconCont">
                            <i class="iconfont icon-shengpi"></i>
                        </div>
                        <div class="textCont">我的审批</div>
                    </div>
                    <div class="btnCont" @click="showMine('我的考勤')">
                        <div class="iconCont">
                            <i class="iconfont icon-kaoqin"></i>
                        </div>
                        <div class="textCont">我的考勤</div>
                    </div>
                    <div class="btnCont" @click="showMine('我的培训')">
                        <div class="iconCont">
                            <i class="iconfont icon-peixun"></i>
                        </div>
                        <div class="textCont">我的培训</div>
                    </div>
                    <div class="btnCont" @click="showMine('我的绩效')">
                        <div class="iconCont">
                            <i class="iconfont icon-jixiaokaohe"></i>
                        </div>
                        <div class="textCont">我的绩效</div>
                    </div>
                    <div class="btnCont" @click="showMine('我的团队')">
                        <div class="iconCont">
                            <i class="iconfont icon-tuandui"></i>
                        </div>
                        <div class="textCont">我的团队</div>
                    </div>
                    <div class="btnCont" @click="showMine('我的动态')">
                        <div class="iconCont">
                            <i class="iconfont icon-dongtaiquan"></i>
                        </div>
                        <div class="textCont">我的动态</div>
                    </div>
                </div>
                <div class="cartogramCont">
                    <div class="title">任务走势统计</div>
                    <div class="searchCont" style="padding:15px 0 0 48px;">
                        <div class="searchContLeft">
                            <el-form
                                :inline="true"
                                :model="searchForm"
                                label-width="120"
                            >
                                <el-form-item label="年" size="mini">
                                    <el-date-picker
                                        v-model="searchForm.Year"
                                        type="year"
                                        value-format="yyyy"
                                        placeholder="请选择年份"
                                        @change="yearHandleChange"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="月" size="mini">
                                    <!-- <el-date-picker
                                        v-model="searchForm.month"
                                        type="month"
                                        value-format="M"
                                        placeholder="请选择月份"
                                        @change="monthHandleChange"
                                    >
                                    </el-date-picker> -->
                                    <el-select
                                        v-model="searchForm.month"
                                        filterable
                                        placeholder="请选择月份"
                                        clearable
                                        @change="monthHandleChange"
                                    >
                                        <el-option
                                            v-for="(item, i) in 12"
                                            :key="i"
                                            :label="item + '月'"
                                            :value="item"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="echart-wrap">
                        <v-chart
                            :auto-resize="true"
                            :options="barOption"
                            ref="eleBar"
                            theme="ovilia-green"
                        />
                    </div>
                </div>
            </div>
            <div class="rightCont">
                <div class="myBusiness">
                    <div class="title">我的任务</div>
                    <el-scrollbar style="height: 100%" v-if="backlogtableData">
                        <!-- <div class="itemCont"
                 :key="index"
                 v-for="(item, index) in backlogtableData">
              <el-tag type="success"
                      size="mini"
                      style="margin-right:10px;">{{ item.event }}</el-tag>
              <div class="itemleftCont">
                <div style="margin-top:2px;">
                  {{ item.message | ellipsis50 }}
                </div>
                <div style="margin-top:4px;">
                  {{ item.create_at }}
                </div>
              </div>
              <div class="itemrightCont">
                <el-button type="primary"
                           plain
                           size="mini"
                           @click="dispose(item)">
                  处理
                </el-button>
              </div>
            </div> -->
                        <div class="itemCont">
                            <el-table
                                :data="tableData"
                                style="width: 100%"
                                height="650px"
                                header-cell-class-name="sortTableHeader"
                                cell-class-name="cellClassName"
                                :header-cell-style="headerCellStyle"
                                :cell-style="cellStyle"
                            >
                                <el-table-column
                                    prop="id"
                                    label="ID"
                                    width="58"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="优先级"
                                    width="92"
                                    property="priority"
                                    sortable
                                >
                                    <template slot-scope="scope">
                                        <p  class="priority"
                                            :class="[
                                                scope.row.priority == 1
                                                    ? 'priority1'
                                                    : scope.row.priority == 2
                                                    ? 'priority2'
                                                    : scope.row.priority == 3
                                                    ? 'priority3'
                                                    : scope.row.priority == 4
                                                    ? 'priority4'
                                                    : ''
                                            ]"
                                        >
                                            <!-- <i class="el-icon-s-flag"></i> -->
                                            <span>{{
                                                scope.row.priority
                                            }}</span>
                                        </p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="title" label="任务名称" align="left">
                                    <template slot-scope="scope">
                                        {{ scope.row.title | ellipsis15 }}
                                    </template>
                                </el-table-column>
                                <el-table-column width="80" label="操作">
                                    <!-- <template slot="header" slot-scope="scope">
                                        状态
                                        <i class="el-icon-caret-bottom"></i>
                                    </template> -->
                                    <template slot-scope="scope">
                                        <span
                                            class="statusBtn"
                                            @click="goJob(scope.row.id)"
                                            >处理</span
                                        >
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <headerDetail
            :rela_code.sync="rela_code"
            :detailVisible.sync="detailVisible"
        ></headerDetail>
        <sureCheck :sureVisible.sync="sureVisible"></sureCheck>
        <auditCheck :auditVisible.sync="auditVisible"></auditCheck>
        <myCheck :myVisible.sync="myVisible"></myCheck>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import headerDetail from "../layout/header/header_detail";
import sureCheck from "../layout/home/sureCheck";
import auditCheck from "../layout/home/auditCheck";
import myCheck from "../layout/home/myCheck";

export default {
    data() {
        return {
            backlogTotal: "",
            backlogPage: "1",
            backlogPerPage: "10",
            backlogtableData: [],
            backlogLoading: false,
            rela_code: "",
            detailVisible: false,
            xAxis: [
                "2020-01",
                "2020-02",
                "2020-03",
                "2020-04",
                "2020-05",
                "2020-06",
                "2020-07",
                "2020-08",
                "2020-09",
                "2020-10",
                "2020-11",
                "2020-12"
            ],
            yAxis: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],

            sureVisible: false,
            auditVisible: false,
            myVisible: false,
            tableData: [],
            searchForm: {
                Year: "",
                year: "",
                month: ""
            },
            xAxisName: "月份"
        };
    },
    created() {
        //this.noticeTips()
        this.myjob();
        this.searchForm.Year = new Date();
        this.searchForm.year = new Date().getFullYear();
        this.jobStatistics();
    },
    components: {
        headerDetail: headerDetail,
        sureCheck: sureCheck,
        auditCheck: auditCheck,
        myCheck: myCheck
    },
    methods: {
        /**
         * 获取待办List
         */
        noticeTips() {
            this.backlogLoading = true;
            oaApi
                .notice(
                    {
                        type: 1,
                        "per-page": this.backlogPerPage,
                        page: this.backlogPage
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        this.backlogVisible = true;
                        this.backlogTotal = res.total;
                        this.backlogtableData = res.data;
                        this.backlogLoading = false;
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.backlogLoading = false;
                });
        },
        /**
         * 列表内处理动作
         */
        dispose(row) {
            this.rela_code = row.rela_code;
            this.backlogVisible = false;
            this.detailVisible = true;
        },
        /**
         * 考勤审核
         */
        showAuditCheck() {
            this.auditVisible = true;
        },
        /**
         * 考勤确认
         */
        showSureCheck() {
            this.sureVisible = true;
        },
        /**
         * 我的系列快捷按钮点击
         */
        showMine(text) {
            if (text == "我的考勤") {
                this.myVisible = true;
            } else {
                this.$message.info("功能正在开发中……");
            }
        },
        /**
         * 修改表头单元格样式
         */
        headerCellStyle({ row, column, rowIndex, columnIndex }) {
            //console.log({ row, column, rowIndex, columnIndex });
            if (columnIndex == 2) return "text-align:left";
        },
        /**
         * 修改单元格样式
         */
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 2) return "font-size:12px;text-align:left";
        },
        /**
         * 获取我的任务
         */
        myjob() {
            oaApi.myjob({}, "get").then(res => {
                //console.log(res)
                if (res.code == 200) {
                    this.tableData = res.data;
                }
            });
        },
        /**
         * 跳转到任务
         */
        goJob(id) {
            this.$router.push({
                path: "/jobManagement",
                query: {
                    id
                }
            });
        },
        /**
         * 获取任务走势统计
         */
        jobStatistics(year) {
            // year && (this.searchForm.year = year);
            // oaApi.jobStatistics({...this.searchForm},"get").then((res)=>{
            oaApi
                .jobStatistics(
                    {
                        year: this.searchForm.year,
                        month: this.searchForm.month
                    },
                    "get"
                )
                .then(res => {
                    if (res.code == 200) {
                        this.xAxis = [];
                        this.yAxis = [];
                        let { data } = res;
                        if (this.searchForm.month) {
                            this.xAxisName = "天数";
                            for (let key in data) {
                                this.xAxis.push(`${key}日`);
                                this.yAxis.push(data[key]);
                            }
                        } else {
                            this.xAxisName = "月份";
                            for (let key in data) {
                                this.xAxis.push(`${key}月`);
                                this.yAxis.push(data[key]);
                            }
                        }
                    }
                });
        },
        yearHandleChange(val) {
            this.searchForm.year = val;
            this.jobStatistics();
        },
        monthHandleChange(val) {
            this.searchForm.month = val;
            this.jobStatistics();
        }
        /* monthHandleClean(){
            
        } */
    },
    computed: {
        userInfo() {
            return this.$store.state.login.userInfo;
        },
        avatar() {
            return this.$store.state.login.avatar;
        },
        barOption() {
            const options = {
                // title: {
                //   text: "工单统计",
                //   left: "20px",
                //   textStyle: {
                //     color: "#000"
                //   }
                // },
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#eb5202"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: this.xAxisName,
                        data: this.xAxis
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "数量(个)"
                    }
                ],
                series: [
                    {
                        name: "任务数",
                        type: "line",
                        data: this.yAxis
                        /* type: "bar",
                        barWidth: "70%",
                        markPoint: {
                            data: [{ type: "max", name: "最大值" }],
                        }, 
                        label:{
                            show:true,
                            position:'top'
                        }*/
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.home {
    background: #f6f7fc;
    min-height: 100%;
    .headCont {
        width: 100%;
        background: #fff;
        height: 120px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .leftCont {
            display: flex;
            .imgCont {
                height: 120px;
                width: 120px;
                display: flex;
                justify-content: center;
                align-items: center;
                .avatar{
                    position: relative;
                    img{
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }
            .cont {
                .welcome {
                    height: 50%;
                    box-sizing: border-box;
                    float: left;
                    font-size: 18px;
                    line-height: 2;
                    text-align: left;
                    padding-top: 30px;
                }
                .job {
                    height: 50%;
                    float: left;
                    font-size: 12px;
                    line-height: 1;
                    padding-top: 20px;
                    text-align: left;
                    color: #999;
                }
            }
        }

        .aboutChecking {
            display: flex;
            height: 100%;
            .itemCont {
                height: 100%;
                padding: 0 20px;
                width: 130px;
                border-radius: 4px;
                // box-sizing: border-box;
                &:hover {
                    cursor: pointer;
                    .numCont {
                        color: $theme-color;
                    }
                }
                .titleCont {
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    height: 60%;
                    padding: 10px 10px 0 10px;
                    box-sizing: border-box;
                    .auditIcon {
                        width: 28px;
                        height: 28px;
                        border-radius: 14px;
                        background: #e6f7ff;
                        i {
                            font-size: 16px;
                            line-height: 28px;
                            text-align: center;
                            color: $theme-color;
                        }
                    }
                    .sureIcon {
                        width: 28px;
                        height: 28px;
                        border-radius: 14px;
                        background: #fff7e6;
                        i {
                            font-size: 16px;
                            line-height: 28px;
                            text-align: center;
                            color: #ffcdb7;
                        }
                    }
                    .title {
                        color: #808695;
                        font-size: 14px;
                    }
                }
                .numCont {
                    font-size: 24px;
                    line-height: 1;
                    text-align: right;
                    color: #515a6e;
                    padding: 0 10px;
                    height: 40%;
                }
            }
        }
    }
    .container {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        .leftCont {
            width: 70%;
            min-height: 700px;
            .fastCont {
                width: 100%;
                background: #fff;
                height: 200px;
                display: flex;
                flex-wrap: wrap;
                .btnCont {
                    display: inline-flex;
                    width: 33.33%;
                    height: 100px;
                    justify-content: center;
                    border-radius: 4px;
                    .iconCont {
                        i {
                            color: $theme-color;
                            font-size: 28px !important;
                            line-height: 100px;
                            transition: font-size 0.2s;
                        }
                    }
                    .textCont {
                        font-size: 14px !important;
                        line-height: 100px;
                        margin: 0 16px;
                        transition: color 0.5s;
                    }
                    &:hover {
                        .iconCont {
                            z-index: 10;
                            i {
                                font-size: 35px !important;
                            }
                        }
                        .textCont {
                            z-index: 10;
                            color: $theme-color;
                        }
                        cursor: pointer;
                    }
                }

                .merge {
                    width: 33.33%;
                    position: relative;
                    overflow: hidden;
                    -webkit-transition: all 0.6s;
                    transition: all 0.6s;
                    &:hover {
                        border-color: #f6f7fc;
                        &::before {
                            border-width: 260px 0 0 260px;
                        }
                        &::after {
                            border-width: 0 260px 260px 0;
                        }
                    }
                    &::before,
                    &::after{
                        content: "";
                        width: 0;
                        height: 0;
                        -webkit-transform: rotate(360deg);
                        transform: rotate(360deg);
                        border-style: solid;
                        border-width: 0;
                        border-top-color: transparent;
                        border-right-color: transparent;
                        border-bottom-color: transparent;
                        position: absolute;
                        -webkit-transition: all 0.6s;
                        transition: all 0.6s;
                    }
                    &::before {
                        border-left-color: #f6f7fc;
                        bottom: 0;
                        left: 0;
                    }
                    &::after {
                        border-right-color: #f6f7fc;
                        top: 0;
                        right: 0;
                    }
                }
            }
            .cartogramCont {
                .title {
                    line-height: 3;
                    font-size: 14px;
                    border-bottom: 1px solid #ddd;
                    text-align: left;
                    text-indent: 20px;
                }
                width: 100%;
                background: #fff;
                height: calc(100% - 200px - 10px);
                margin-top: 10px;
                position: relative;
                .echart-wrap {
                    position: absolute;
                    bottom: 20px;
                    width: 100%;
                    .echarts {
                        width: 100%;
                    }
                }
                .searchCont {
                    .el-input--mini {
                        min-width: 110px;
                        width: 110px;
                        .el-input__inner {
                            width: 110px;
                        }
                    }
                }
            }
        }
        .rightCont {
            width: calc(100% - 70% - 10px);
            margin-left: 10px;
            background: #fff;
            min-height: 700px;
            .myBusiness {
                width: 100%;
                position: relative;
                .title {
                    line-height: 3;
                    font-size: 14px;
                    border-bottom: 1px solid #ddd;
                    text-align: left;
                    text-indent: 20px;
                }
                .itemCont {
                    // height: 60px;
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    box-sizing: border-box;
                    padding: 15px 15px 0 !important;
                    // border-top: 1px #ddd solid;
                    .itemleftCont {
                        width: 100%;
                        div {
                            // height: 18px;
                            width: 90%;
                            line-height: 14px;
                            font-size: 12px;
                            display: flex;
                            flex-direction: column-reverse;
                            justify-content: space-around;
                            text-align: left;
                            padding: 6px 0;
                        }
                    }
                    .itemrightCont {
                    }
                    .has-gutter {
                        .gutter {
                            background-color: #fff !important;
                        }
                        .is-leaf {
                            border-bottom: 1px solid #dddddd;
                        }
                    }
                    .sortTableHeader {
                        background: #fff !important;
                        color: #333333;
                        text-align: center;
                        font-weight: 500;
                        padding-bottom: 5px;
                        font-size: 12px;
                    }
                    .cellClassName {
                        text-align: center;
                        height: 35px;
                    }
                    .statusBtn {
                        color: #8978c4;
                        font-size: 12px;
                        cursor: pointer;
                        &:active {
                            opacity: 0.6;
                            user-select: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
